
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M9.491 14c-1.54 0-2.73 1.39-2.45 2.91 1.92 10.33 11.4 18.18 22.8 18.18s20.88-7.85 22.8-18.18c.28-1.51-.91-2.91-2.45-2.91h-40.7z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M21.191 33.5v6.09c0 1.68 1.36 3.04 3.04 3.04s3.04-1.36 3.04-3.04v-4.63m4.89-2.22v8.31c0 1.68 1.36 3.04 3.04 3.04s3.04-1.36 3.04-3.04V30.31m4.19 1.24v3.73c0 1.68 1.36 3.04 3.04 3.04s3.04-1.36 3.04-3.04v-9.19m-37.55-.29v9.48c0 1.68 1.36 3.04 3.04 3.04s3.04-1.36 3.04-3.04v-8.73"}})])
          )
        }
      }
    